module.exports = __webpack_public_path__ + "img/wa06.db7b1a08.jpg";